import { render, staticRenderFns } from "./crm-home.vue?vue&type=template&id=34d771cd&scoped=true&"
import script from "./crm-home.vue?vue&type=script&lang=js&"
export * from "./crm-home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d771cd",
  null
  
)

export default component.exports